import React, {useState} from 'react';
import {Button, Row, Col, Modal} from 'reactstrap';
import {useForm} from 'react-hook-form';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import {SweetAlert} from '../Common/SweetAlert';
import axios from 'axios';

const ModalAddPartsOrderNo = ({claim}) => {
  const [modal, setModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {register, handleSubmit, reset} = useForm();

  const toggleModal = () => {
    setModal(!modal);
    document.body.classList.add('no_padding');
  };

  const sendPartsOrderNo = (data) => {
    const url = `${process.env.REACT_APP_APIURL}claim/${claim.id}/partsorderno`;
    const authToken = authHeader();

    const formData = new FormData();
    formData.append('data', JSON.stringify(data));

    setIsLoading(true);
    axios
        .post(url, formData, {headers: authToken})
        .then(() => {
          setIsLoading(false);
          setSuccessMsg(true);
          reset();
        })
        .catch(() => {
          setIsLoading(false);
          setErrorMsg(true);
        });
  };

  const onSubmit = (values) => {
    sendPartsOrderNo(values);
  };

  return (
    <>
      <button
        className="position-absolute top-15 right-15 p-0 waves-effect waves-light btn btn-transparent text-yellow"
        type="button"
        onClick={toggleModal}
      >
        <i className="font-size-20 mdi mdi-square-edit-outline"></i>
      </button>

      <Modal size="lg" isOpen={modal} toggle={toggleModal} centered>
        <div className="modal-body">
          <button type="button" className="close" onClick={() => setModal(false)}>
            <span aria-hidden="true">&times;</span>
          </button>

          <Row>
            <Col md={1}>
              <div className="avatar-sm">
                <span className="avatar-title rounded-circle bg-primary text-white">
                  <i className="bx bx-refresh bx-sm rotateInUpLeft"></i>
                </span>
              </div>
            </Col>

            <Col md={11}>
              <h5 className="modal-title mt-0">Add Parts Order No</h5>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md={12}>
                    <div className="d-flex gap-3 mb-3">
                      <label>
                        <input type="radio" value="CN" {...register('type', {required: true})} /> CN
                      </label>
                      <label>
                        <input type="radio" value="FOC" {...register('type', {required: true})} /> FOC
                      </label>
                    </div>
                  </Col>

                  <Col md={12}>
                    <textarea
                      rows="5"
                      className="form-control"
                      placeholder="Number"
                      {...register('number', {required: true})}
                    />
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col md={8}></Col>
                  <Col md={4}>
                    <div className="text-sm-right">
                      <Button color="yellow" type="submit" disabled={isLoading}>
                        {isLoading && <i className="bx bx-loader bx-spin mr-2" />}
                        Add Parts Order No
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </div>
      </Modal>

      {successMsg && (
        <SweetAlert
          title="Good job!"
          success
          onConfirm={() => window.location.reload()}
        >
          Parts Order Number was submitted successfully.
        </SweetAlert>
      )}

      {errorMsg && (
        <SweetAlert
          title="Request could not be submitted!"
          warning
          onConfirm={() => setErrorMsg(false)}
        >
          There was an error while submitting your request. Please try again or get in contact with our team.
        </SweetAlert>
      )}
    </>
  );
};

export default ModalAddPartsOrderNo;
